"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.NameserviceTransaction = void 0;
const crypto_1 = require("@arkecosystem/crypto");
const utils_1 = require("@protokol/utils");
const bytebuffer_1 = __importDefault(require("bytebuffer"));
const enums_1 = require("../enums");
const nameservice_schemas_1 = require("./utils/nameservice-schemas");
const { schemas } = crypto_1.Transactions;
class NameserviceTransaction extends crypto_1.Transactions.Transaction {
    static getSchema() {
        return schemas.extend(schemas.transactionBaseSchema, {
            $id: this.key,
            required: ["asset", "typeGroup"],
            properties: {
                type: { transactionType: this.type },
                typeGroup: { const: this.typeGroup },
                amount: nameservice_schemas_1.amountSchema,
                vendorField: nameservice_schemas_1.vendorFieldSchema,
                asset: {
                    type: "object",
                    required: ["nameservice"],
                    properties: {
                        nameservice: nameservice_schemas_1.nameserviceSchema,
                    },
                },
            },
        });
    }
    serialize() {
        var _a;
        const { data } = this;
        utils_1.Asserts.assert.defined((_a = data.asset) === null || _a === void 0 ? void 0 : _a.nameservice);
        const nameserviceAsset = data.asset.nameservice;
        const hashBuffer = Buffer.from(nameserviceAsset.name);
        const buffer = new bytebuffer_1.default(1 + hashBuffer.length, true);
        // name
        buffer.writeByte(hashBuffer.length);
        buffer.append(hashBuffer, "hex");
        return buffer;
    }
    deserialize(buf) {
        const { data } = this;
        // name
        const nameLength = buf.readUint8();
        const name = buf.readBytes(nameLength).toBuffer().toString("utf8");
        const nameservice = { name };
        data.asset = {
            nameservice,
        };
    }
    hasVendorField() {
        return true;
    }
}
exports.NameserviceTransaction = NameserviceTransaction;
Object.defineProperty(NameserviceTransaction, "typeGroup", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: enums_1.NameServiceTransactionGroup
});
Object.defineProperty(NameserviceTransaction, "type", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: enums_1.NameServiceTransactionTypes.Nameservice
});
Object.defineProperty(NameserviceTransaction, "key", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: "Nameservice"
});
Object.defineProperty(NameserviceTransaction, "version", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: enums_1.NameServiceTransactionVersion
});
Object.defineProperty(NameserviceTransaction, "defaultStaticFee", {
    enumerable: true,
    configurable: true,
    writable: true,
    value: crypto_1.Utils.BigNumber.make(enums_1.NameServiceStaticFees.Nameservice)
});
//# sourceMappingURL=nameservice.js.map